var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-deposit-create"}},[_c('vx-card',[_c('div',{staticClass:"vx-row w-full"},[_c('h3',[_vm._v(_vm._s(_vm.message))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }